import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import TextField from 'forms/shared/fields/text'
import CheckboxField from 'forms/shared/fields/checkbox'
import { reduxForm, Field, submit, change, formValueSelector } from 'redux-form'
import LoadingOverlay from 'components/shared/loaders/loading-overlay';
import { FORM_SECTIONS } from 'constants/user-venues';
import { FORM_ERROR_CLASS, INPUT_ERROR_CLASS, MERCHANT_FORM_LABEL, MERCHANT_INPUT_CLASS } from 'constants/css-style'
import validate from './validator'

const ContactActionForm = ({ dispatch, form, loading, setSelectedSection, handleSetSuccess, notification: { type }, imageAvatar }) => {
  const file = useRef()
  const noAvatar = require('assets/images/default-profile.png')

  const [avatar, setAvatar] = useState(noAvatar)

  const handleAvatarChange = () => {
    const files = file.current.files
    if (files && files.length) {
      const reader = new FileReader()
      reader.readAsDataURL(files[0]);
      reader.onload = () => {
        dispatch(change(form, 'file', files[0]))
        setAvatar(reader.result)
      }
      reader.onerror = (error) => {
        console.log('Error: ', error);
      };
    }
  }
  useEffect(() => {
    if (type === 'success') {
      setSelectedSection(FORM_SECTIONS.SPACES)
      handleSetSuccess({ [FORM_SECTIONS.CONTACTS]: true })
    }
  }, [type])

  useEffect(() => {
    imageAvatar && setAvatar(imageAvatar)
  }, [imageAvatar])

  return (
    <LoadingOverlay loading={loading}>
      <div className="py-2">
        <div className="flex">
          <div className="w-1/5">
            <div className="font-semibold text-center">Contact Image</div>
            <div className="w-full py-1">
              <img alt="avatar" src={avatar} className="mx-auto rounded-full object-cover w-50 h-50" />
            </div>
            <div className="w-full text-center py-6">
              <input ref={file} type="file" accept="image/x-png,image/jpeg" className="hidden" onChange={handleAvatarChange} />
              <button onClick={() => file.current.click()} className="bg-white w-auto text-primary-orange px-6 py-3 border-2 border-primary-orange rounded-b-lg md:rounded-lg focus:outline-none">SELECT IMAGE</button>
            </div>
          </div>
          <div className="w-4/5 px-10">
            <div className="flex flex-wrap">
              <Field
                type={'text'}
                name={'name'}
                label={'Name'}
                groupClassName="my-3 w-5/12"
                placeholder={'Type in Contact Name'}
                labelClassName={MERCHANT_FORM_LABEL}
                inputClassName={MERCHANT_INPUT_CLASS}
                inputErrorClassName={INPUT_ERROR_CLASS}
                errorClassName={FORM_ERROR_CLASS}
                component={TextField}
              />
              <div className="w-1/6"></div>
              <Field
                type={'text'}
                name={'email'}
                label={'Email'}
                groupClassName="my-3 w-5/12"
                placeholder={'Type in Contact Email'}
                labelClassName={MERCHANT_FORM_LABEL}
                inputClassName={MERCHANT_INPUT_CLASS}
                inputErrorClassName={INPUT_ERROR_CLASS}
                errorClassName={FORM_ERROR_CLASS}
                component={TextField}
              />
              <Field
                type={'text'}
                name={'role'}
                label={'Role'}
                groupClassName="my-3 w-5/12"
                placeholder={'Type in Contact Role'}
                labelClassName={MERCHANT_FORM_LABEL}
                inputClassName={MERCHANT_INPUT_CLASS}
                inputErrorClassName={INPUT_ERROR_CLASS}
                errorClassName={FORM_ERROR_CLASS}
                component={TextField}
              />
              <div className="w-1/6"></div>
              <Field
                type={'text'}
                name={'phone'}
                label={'Phone'}
                groupClassName="my-3 w-5/12"
                placeholder={'Type in Contact Mobile No.'}
                labelClassName={MERCHANT_FORM_LABEL}
                inputClassName={MERCHANT_INPUT_CLASS}
                inputErrorClassName={INPUT_ERROR_CLASS}
                errorClassName={FORM_ERROR_CLASS}
                component={TextField}
              />
              <div className="w-full flex py-4">
                <div className="w-1/2">
                  <Field
                    type={'checkbox'}
                    styles={{ borderRadius: '9999px' }}
                    name={'can_receive_sms'}
                    label={'Receive SMS Notifications'}
                    groupClassName="w-full mb-3"
                    labelClassName="text-primary-black text-base"
                    inputClassName={MERCHANT_INPUT_CLASS}
                    inputErrorClassName={INPUT_ERROR_CLASS}
                    errorClassName={FORM_ERROR_CLASS}
                    component={CheckboxField}
                  />
                  <p className="text-sm text-dim-gray">{`Ensure you don't miss a lead while on the go.`}</p>
                  <p className="text-sm text-dim-gray">{`Don't worry - you will not receive any spam.`}</p>
                </div>
                <div className="w-1/2 flex justify-end">
                  <button onClick={() => dispatch(submit(form))} className="bg-primary-orange max-h-max w-1/2 text-white px-2 py-3 rounded-b-lg md:rounded-lg focus:outline-none">SAVE CONTACT</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  )
}

ContactActionForm.propTypes = {
  loading: PropTypes.bool,
  setSelectedSection: PropTypes.func,
  handleSetSuccess: PropTypes.func,
  notification: PropTypes.object,
  dispatch: PropTypes.func,
  form: PropTypes.string,
  imageAvatar: PropTypes.string,
}

const mapStateToProps = ({ contacts, notification, ...state }, { form }) => {
  const selector = formValueSelector(form)
  return {
    loading: contacts.fetching,
    notification,
    imageAvatar: selector(state, 'image_filename'),
  }
}

export default reduxForm({ validate, enableReinitialize: true })(connect(mapStateToProps)(ContactActionForm))
